module.exports = __webpack_public_path__ + "img/cd.0d9305d0.png";